import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Mockups } from "@/components/landing/Mockups";
import { Showcase } from "@/components/landing/Showcase";
import { Manifesto } from "@/components/landing/Manifesto";
import { CTA } from "@/components/landing/CTA";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative bg-black">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Mockups />
        <Showcase />
        <Manifesto />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
